module.exports = __webpack_public_path__ + "media/images/responsive/fairs/present_title-a3edebf4e77fe41498deb1c707807512.png";